module.exports = __webpack_public_path__ + "static/media/Join-Image.a34053b0.png";